var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tbc-t menu-scroll"},[_c('el-drawer',{attrs:{"title":"目录","visible":_vm.h5,"direction":"btt"},on:{"update:visible":function($event){_vm.h5=$event}}},[_c('MenuTree',{key:0,attrs:{"data":_vm.treeData,"target":"treeData"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }